import { render, staticRenderFns } from "./GLoading.vue?vue&type=template&id=356d2a9b&scoped=true&"
import script from "./GLoading.vue?vue&type=script&lang=js&"
export * from "./GLoading.vue?vue&type=script&lang=js&"
import style0 from "./GLoading.vue?vue&type=style&index=0&id=356d2a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d2a9b",
  null
  
)

export default component.exports